export enum EkranBrakuPrezentacjiKwotyPoKalkulacji {
    USTAW_STAN_KWOTA_UKRYTA = '[Ekran braku prezentacji kwoty po kalkulacji] Ustawiono stan samoobslugi',
    WYSLIJ_STAN_KWOTA_UKRYTA = '[Ekran braku prezentacji kwoty po kalkulacji] Wyslij stan samoobslugi',
    USTAW_STAN_KWOTA_UKRYTA_SUCCESS = '[Ekran braku prezentacji kwoty po kalkulacji] Ustawiono stan samoobslugi success',
    ZAPISZ_STORE_PO_ZMIANIE_STANU_NA_KWOTA_UKRYTA = '[Ekran braku prezentacji kwoty po kalkulacji] Zapisz store po zmianie stanu na kwota ukryta',
}
